module.exports = __webpack_public_path__ + "img/well_floorplan.8c5a7801.svg";